<template>
    <table class="uk-table uk-margin-top">
        <thead>
            <tr>
                <th>Quick Phases Setup</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Total Fee</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="project_phase in project_phases"
                :key="project_phase.id"
            >
                <td><strong>{{ project_phase.name }}</strong></td>
                <td>
                    <form-date-input
                        :id="`phase-${project_phase.id}-starts-at-${id}`"
                        :value="field_value('starts_at', project_phase.id)"
                        name="starts_at"
                        :min-date="1"
                        :editable="true"
                        :required="false"
                        class="uk-width-1-1"
                        @input="$emit('change', project_phase.id, $event, 'starts_at')"
                    />
                </td>
                <td>
                    <form-date-input
                        :id="`phase-${project_phase.id}-ends-at-${id}`"
                        :value="field_value('ends_at', project_phase.id)"
                        name="ends_at"
                        :editable="true"
                        :required="false"
                        class="uk-width-1-1"
                        @input="$emit('change', project_phase.id, $event, 'ends_at')"
                    />
                </td>
                <td>
                    <form-input
                        :id="`phase-${project_phase.id}-fee-${id}`"
                        :value="field_value('fee', project_phase.id)"
                        type="float"
                        name="fee"
                        glyph="dollar"
                        :editable="true"
                        :required="false"
                        class="uk-width-1-1"
                        @input="$emit('change', project_phase.id, $event, 'fee')"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script type="text/javascript">
import string_utilities from "../mixins/StringUtilities"

import FormDateInput from "./FormDateInput"
import FormInput from "./FormInput"

export default {
    mixins: [string_utilities],
    components: {
        FormDateInput,
        FormInput
    },
    methods: {
        project_phase (project_phase_id) {
            if(!this.value) return {}
            return this.value[project_phase_id]
        },
        field_value (field, project_phase_id) {
            const project_phase = this.project_phase(project_phase_id)
            if(!project_phase) return null
            return project_phase[field]
        }
    },
    computed: {
        project_phases () {
            return this.dictionary("project_phase")
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    }
    /*
    components: {
        AutoSaveDate,
        AutoSaveFloat,
        PhaseTemplates,
        PhaseTemplateHelp,
        OpenIcon
    },
    mixins: [utilities], //, phases_utilities],
    methods: {
        phase_data_empty (phase_id, field) {
            this.$emit("empty", phase_id, field)
        },
        phase_data_set (phase_id, field, value) {
            this.$emit("set", phase_id, field, value)
        },
        phase_template_value (phase_id) {
            if(!this.value) return 0
            return this.value[phase_id].service_level_id || 0
        },
        phase_template_is_checked (phase_id, service_level_id) {
            if(!this.value) return false
            return this.value[phase_id].service_level_id === service_level_id
        },
        toggle_phase_template (event, phase_id, service_level_id) {
            if(this.phase_template_is_checked(phase_id, service_level_id)) {
                this.phase_data_set(phase_id, 'service_level_id', 0)
            } else {
                this.phase_data_set(phase_id, 'service_level_id', service_level_id)
            }
        },

        template_help (project_phase_id) {
            this.template_helping = project_phase_id
        },
    },
    computed: {
        loaded () {
            return !isEmpty(this.value)
        },
        project_phases () {
            return this.dictionary('project_phase')
        },
        service_levels () {
            return this.dictionary('service_level')
        },
    },
    data () {
        return {
            template_helping: null,
        }
    }
    */
}
</script>
